export const MAX_TASK_MESSAGE_LENGTH = 1000;
export const SUPPORT_EMAIL = 'support@cairns.ai';

export const LINKS_TO_MARKET = {
  //TODO: add android store link
  android: '',
  ios: 'https://apps.apple.com/us/app/cairns-companion/id6737698311'
};
